import { InputAdornment, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import Input from "./Input";
import { forwardRef } from "react";

type TextFieldProps = React.ComponentProps<typeof TextField>;

interface SearchFieldProps extends TextFieldProps {
  hiddenLabel?: boolean;
}

const SearchField = forwardRef<HTMLInputElement, SearchFieldProps>((props, ref) => {
  const { placeholder, value, onChange, sx, slotProps, hiddenLabel = true, ...rest } = props;

  return (
    <Input
      ref={ref}
      hiddenLabel={hiddenLabel}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      slotProps={{
        ...(slotProps as any),
        input: {
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon fontSize="small" />
            </InputAdornment>
          ),
          ...((slotProps as any)?.input),
        },
      }}
      sx={{
        "& .MuiInputBase-input": { py: 0.75 },
        ...sx,
      } as any}
      {...rest}
    />
  );
});

SearchField.displayName = "SearchField";

export default SearchField;
